import App from 'App';
import * as React from 'react';
import * as ReactDOM from 'react-dom';
import { APP_BLINKET_URL } from 'settings';

const { pathname, search, hash } = window.location;
const query = new URLSearchParams(search);

// acesso pelo app da Eduzz não redireciona: o deep link entra com fat_cod e a navegação interna carrega eduzzapp=true
const isEduzzAppAccess = query.get('eduzzapp') === 'true' || query.has('fat_cod');

if (APP_BLINKET_URL && !isEduzzAppAccess) {
  window.location.replace(`${APP_BLINKET_URL}${pathname}${search}${hash}`);
} else {
  ReactDOM.render(<App />, document.getElementById('root') as HTMLElement);
}

if ('serviceWorker' in navigator) {
  navigator.serviceWorker.ready.then(registration => {
    registration.unregister();
  });
}
